import React, { useState } from 'react';
import { Card, DashedAddButton, PillButton, Stack, Text } from 'library/ui';
import { usePostJobNavigation } from 'parent-portal/jobs/postJob/usePostJobNavigation';
import moment from 'moment';
import { isBefore, isToday } from 'date-fns';
import { useFeatureFlag, FeatureFlag } from 'shared';
import useMicrodepositVerificationInfo from 'parent-portal/home/paymentVerificationWarning/useMicrodepositVerficationInfo';
import MissingMicrodepositVerificationModal from 'parent-portal/home/paymentVerificationWarning/MissingMicrodepositVerificationModal';

import { AutoHireWorkerDialog } from './AutoHireWorker/AutoHireWorkerDialog';
import { useUserContext } from 'UserContext';
import { useBlockedCounty } from 'parent-portal/shared/BlockedCounty/useBlockedCounty';
import { BlockedCountyWarningDialog } from 'parent-portal/shared/BlockedCounty/BlockedCountyWarningDialog';

export default function PostAShiftCard({
    d,
    addressId,
    refresh,
}: {
    d: Date;
    addressId?: number;
    businessLocationId?: number;
    timezone?: string;
    refresh: () => void;
}) {
    const { user } = useUserContext();
    const canPostJobs = user?.address.some((x) => x.can_post_jobs);
    const { goToPostJob } = usePostJobNavigation();
    const { featureActive: active } = useFeatureFlag(FeatureFlag.AUTOSCHEDULE_WORKER);
    const [open, setOpen] = useState(false);
    const [missingOpen, setMissingOpen] = useState(false);
    const [blockedCountyOpen, setBlockedCountyOpen] = useState(false);
    const { blockJobPostingOnVerification } = useMicrodepositVerificationInfo();
    const { isInBlockedCounty } = useBlockedCounty();

    function onAddWorkerClick() {
        if (isInBlockedCounty) {
            setBlockedCountyOpen(true);
            return;
        }
        blockJobPostingOnVerification ? setMissingOpen(true) : setOpen(true);
    }

    if (isBefore(d, new Date()) && !isToday(d)) {
        return <></>;
    }

    if (!canPostJobs) {
        return <></>;
    }

    return (
        <Card tone="muted" padding="sm">
            <Stack gap="md">
                <Stack gap="sm" align="start">
                    <Text size="sm">Post a shift for {d.toLocaleDateString()}.</Text>
                    <PillButton
                        onClick={() =>
                            goToPostJob('Post a job card (Business Calendar)', {
                                startDate: moment(d).format('YYYY-MM-DD'),
                                endDate: moment(d).format('YYYY-MM-DD'),
                                addressIds: addressId ? [addressId] : undefined,
                            })
                        }
                    >
                        Post Shift
                    </PillButton>
                </Stack>
                {active && (
                    <Stack gap="sm" align="start">
                        <Text size="xs" weight="bold">
                            OR
                        </Text>
                        <Text size="sm">
                            Automatically add a previous worker to the schedule.
                            <b>
                                <u> They must have already agreed to the shift.</u>
                            </b>
                        </Text>
                        <DashedAddButton size="sm" onClick={onAddWorkerClick}>
                            Add Worker
                        </DashedAddButton>
                        <AutoHireWorkerDialog
                            open={open}
                            setOpen={setOpen}
                            addressId={addressId}
                            defaultDay={d}
                            refresh={refresh}
                        />
                    </Stack>
                )}
                <MissingMicrodepositVerificationModal isOpen={missingOpen} onClose={() => setMissingOpen(false)} />
                <BlockedCountyWarningDialog open={blockedCountyOpen} onClose={() => setBlockedCountyOpen(false)} />
            </Stack>
        </Card>
    );
}
